
import { GlobalVars } from "../state/global/globalVars";
import PageBody from "../components/ui/layout/PageBody";
import ReactModal from "react-modal";

export default function Home() {
    return (
        <PageBody title="Dashboard (WIP)">
            <div className="space-y-4">
            </div>
        </PageBody>
    );
}
